import React, { useState } from 'react';
import BoardStatusSelector from './BoardStatusSelector';

function AddBoardButton({ onAddBoard, loading }) {
  const [isAdding, setIsAdding] = useState(false);
  const [newBoardName, setNewBoardName] = useState('');
  const [newBoardStatus, setNewBoardStatus] = useState('new');

  const handleAdd = async () => {
    if (newBoardName.trim()) {
      try {
        await onAddBoard(newBoardName.trim(), '#007bff', newBoardStatus);
        setNewBoardName('');
        setNewBoardStatus('new');
        setIsAdding(false);
      } catch (error) {
        // Error handled by parent
      }
    }
  };

  const handleCancel = () => {
    setNewBoardName('');
    setNewBoardStatus('new');
    setIsAdding(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAdd();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  if (isAdding) {
    return (
      <div style={{
        flex: '0 0 300px',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '8px',
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
      }}>
        <input
          type="text"
          placeholder="Enter board name..."
          value={newBoardName}
          onChange={(e) => setNewBoardName(e.target.value)}
          onKeyDown={handleKeyPress}
          autoFocus
          style={{
            padding: '8px',
            border: '2px solid #007bff',
            borderRadius: '4px',
            fontSize: '1rem'
          }}
        />
        
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '8px',
          marginBottom: '8px'
        }}>
          <label style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
            Status:
          </label>
          <BoardStatusSelector
            currentStatus={newBoardStatus}
            onStatusChange={setNewBoardStatus}
          />
        </div>
        
        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            onClick={handleAdd}
            disabled={!newBoardName.trim() || loading}
            style={{
              flex: 1,
              padding: '8px 12px',
              backgroundColor: !newBoardName.trim() || loading ? '#6c757d' : '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: !newBoardName.trim() || loading ? 'not-allowed' : 'pointer',
              fontSize: '0.9rem',
              fontWeight: '500'
            }}
          >
            {loading ? 'Adding...' : 'Add Board'}
          </button>
          <button
            onClick={handleCancel}
            style={{
              flex: 1,
              padding: '8px 12px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '0.9rem',
              fontWeight: '500'
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  }

  return (
    <button
      onClick={() => setIsAdding(true)}
      style={{
        flex: '0 0 300px',
        height: '200px',
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        border: '2px dashed rgba(255, 255, 255, 0.7)',
        borderRadius: '8px',
        color: 'white',
        fontSize: '1.1rem',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '8px',
        transition: 'all 0.2s ease'
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.4)';
        e.target.style.borderColor = 'rgba(255, 255, 255, 0.9)';
        e.target.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.3)';
        e.target.style.borderColor = 'rgba(255, 255, 255, 0.7)';
        e.target.style.transform = 'translateY(0)';
      }}
    >
      <span style={{ fontSize: '2rem' }}>+</span>
      Add New Board
    </button>
  );
}

export default AddBoardButton;